// @flow
import React, { Component } from "react";
import config from "../../../data/SiteConfig";
import container from "../../styles/container.module.css";
import styles from "./Footer.module.css";

type Props = {};

type State = {};

class Footer extends Component<Props, State> {
  render() {
    return (
      <div className={styles.wrapper}>
        <div className={container.default}>
          <div className={styles.footer}>
            <a className={styles.copyright} href="https://www.templarbit.com/">
              {config.copyright}
            </a>
            <a
              className={styles.clearbitLink}
              href="https://clearbit.com/"
              traget="_blank"
            >
              Logos provided by Clearbit
            </a>
            <a className={styles.rss} href={`${config.siteUrl}rss.xml`}>
              RSS Feed
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js